import { computed, makeObservable } from 'mobx';
import type { InputState } from '../../components/input/input.state';
import { IkeInputStateGroup } from '../../components/input/input.state.group';

export class CollectionChangeState {
	private state: IkeInputStateGroup;
	startTime: number;

	constructor() {
		makeObservable(this);

		this.startTime = Date.now();
		this.state = new IkeInputStateGroup();
		this.state.isLabelShown = false;
	}

	getState<T = string>(fieldId: string): InputState<T> {
		return this.state.get(fieldId);
	}

	addState<T>(fieldId: string, state: InputState<T>) {
		state.id = fieldId;
		this.state.add(state);
	}

	@computed get isValid(): boolean {
		return this.state.isValid;
	}

	destroy() {
		this.state.destroy();
	}
}
